import Plot from "react-plotly.js"

const DefaultPlot = ({ data, width }) => {
  return <Plot
    data={data}
    layout={{
      legend: {orientation:'h', x: 0.45, y: -0.2, xanchor: 'center', font: { family: 'Montserrat, sans- serif' } },
      width: width || 1000,
      height: 600,
      xaxis: {
        titlefont: {
          size: 12,
        },
      },
      yaxis: {
        titlefont: {
          size: 12,
        },
      },
    }}
    config={{
      locale: "pt-br",
      displaylogo: false,
      responsive: true,
    }}
  />
}

export default DefaultPlot